import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { EmptyState } from '@/components/ui';

const NotFound = () => (
  <div className="flex min-h-screen flex-col bg-surface-muted">
    <Header />
    <main className="lk-container flex-1 py-20">
      <EmptyState
        icon={Compass}
        title="This page doesn't exist"
        message="The link may be out of date, or the event has been taken offline."
        action={
          <Link to="/" className="lk-btn-primary">
            Back to events
          </Link>
        }
      />
    </main>
    <Footer />
  </div>
);

export default NotFound;
